export interface Article {
  slug: string
  title: string
  category: string
  date: string
  image: string
  excerpt: string
  content: string[]
}

export const articles: Article[] = [
  {
    slug: 'az-city-pac-arizona-biltmore-event',
    title: 'AZ City PAC to Host August 19 Event at the Arizona Biltmore',
    category: 'Events',
    date: 'August 19, 2026',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/76e3cf62-a0f2-4ead-9765-f0b029dc6b87.jpg',
    excerpt:
      'Arizona City PAC will host a conversation on local leadership and stronger communities during the League of Arizona Cities and Towns gathering.',
    content: [
      'Arizona City PAC is excited to attend the upcoming League of Arizona Cities and Towns gathering on August 19, 2026, at the Arizona Biltmore. During the event, we will host a special conversation focused on increasing awareness of the PAC and sharing our goals for Arizona’s cities and communities.',
      'Arizona City PAC brings together local elected officials, business leaders, and community advocates who believe decisions affecting our cities are best made at the local level. Our mission is to protect local decision-making, encourage responsible economic growth, promote safe neighborhoods, and preserve the quality of life Arizona residents value.',
      'We look forward to connecting with leaders from across the state, building strong partnerships, and sharing how Arizona City PAC can support the people working every day to move their communities forward.',
    ],
  },
  {
    slug: 'local-planning-authority',
    title: 'Arizona Cities Unite to Protect Local Planning Authority',
    category: 'Local Control',
    date: 'October 12, 2025',
    image:
      'https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=85',
    excerpt:
      'AZ City PAC is advocating for policies that preserve municipal authority to shape housing, land use, and growth responsibly.',
    content: [
      'Arizona’s cities and towns are at their best when the people closest to a community can help shape its future. Local elected officials and residents understand the character of their neighborhoods, the capacity of their infrastructure, and the practical needs of the families and businesses they serve.',
      'AZ City PAC supports policies that preserve municipal authority over land use, zoning, and community planning. Local planning is not a one-size-fits-all exercise. What works in a growing suburb, a rural town, or an established urban neighborhood may be very different—and local leaders need the flexibility to respond accordingly.',
      'Thoughtful planning helps communities balance housing opportunity, transportation, public services, open space, and economic development. It gives residents a meaningful voice in decisions that affect their daily lives while helping cities prepare responsibly for long-term growth.',
      'We are committed to building bipartisan support for practical solutions that respect local decision-making and help Arizona communities remain strong, responsive, and ready for the future.',
    ],
  },
  {
    slug: 'resilient-infrastructure',
    title: 'Arizona Municipal Leaders Discuss Resilient Infrastructure',
    category: 'Infrastructure',
    date: 'September 15, 2025',
    image:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=85',
    excerpt:
      'Investing in infrastructure that meets the distinct needs of local communities remains a core priority for AZ City PAC.',
    content: [
      'Reliable infrastructure is the foundation of every thriving community. Roads, water systems, public facilities, technology, and emergency services all require long-term planning and investments that reflect local priorities.',
      'Arizona’s communities face distinct challenges and opportunities. Population growth, economic development, climate realities, and changing transportation needs require local leaders to plan with both urgency and care. A statewide approach must leave room for each city and town to determine what will serve its residents best.',
      'AZ City PAC supports collaborative policies that give municipal leaders the tools to plan, maintain, and modernize the infrastructure their communities depend on. We believe public and private partners can work together to deliver durable solutions that protect taxpayers and support sustainable growth.',
      'By centering local expertise in infrastructure conversations, Arizona can build communities that are more resilient, more connected, and better prepared for generations to come.',
    ],
  },
]

export function getArticleBySlug(
  slug: string | undefined,
): Article | undefined {
  return articles.find((article) => article.slug === slug)
}
